
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/shared/g-maps.kpa`,
      template: `<section class="g-maps" ref="g-maps">
        <div class="wrapper">
            <div id="map" class="box-shadow">
                {{ consentMessage }}
            </div>
        </div>
    </section>`,
      style: `g-maps .g-maps {
  margin: 0;
  padding: 0;
  margin-top: 96px;
}
g-maps .g-maps .wrapper {
  padding: 0;
}
g-maps .g-maps .wrapper #map {
  position: relative;
  width: 100%;
  height: 500px;
  z-index: 1;
  border-radius: 8px;
}
g-maps .g-maps .wrapper #map .gm-style-mot {
  color: #ffffff;
  text-shadow: 4px 4px 8px rgba(0, 0, 0, 0.8);
  margin: 0 auto;
}
g-maps .g-maps .wrapper #map .info-window {
  font-family: Arial, sans-serif;
  color: #333;
  width: 250px;
  padding: 10px;
  box-sizing: border-box;
  font-size: 14px;
}
g-maps .g-maps .wrapper #map .info-window h3 {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 5px 0;
}
g-maps .g-maps .wrapper #map .info-window p {
  margin: 5px 0;
  font-size: 14px;
  color: #555;
}
g-maps .g-maps .wrapper #map .info-window .rating {
  font-size: 14px;
  margin: 5px 0;
}
g-maps .g-maps .wrapper #map .info-window .rating .rating-value {
  font-weight: bold;
}
g-maps .g-maps .wrapper #map .info-window .rating .star {
  color: #f5c518;
}
g-maps .g-maps .wrapper #map .info-window .route-link,
g-maps .g-maps .wrapper #map .info-window .map-link {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
  margin-top: 10px;
  display: inline-block;
}
g-maps .g-maps .wrapper #map .info-window .route-link:hover,
g-maps .g-maps .wrapper #map .info-window .map-link:hover {
  text-decoration: underline;
}
g-maps .g-maps .wrapper #map div.consent-message {
  display: block;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding: 24px;
  box-sizing: border-box;
  gap: 16px;
  text-align: center;
  background: #f4f6f3;
  color: #24362b;
}
g-maps .g-maps .wrapper #map div.consent-message p {
  max-width: 640px;
  margin: 0;
  line-height: 1.6;
}
g-maps .g-maps .wrapper #map div.consent-message .consent-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 16px;
}
g-maps .g-maps .wrapper #map div.consent-message button {
  color: inherit;
  font: inherit;
}
g-maps .g-maps .wrapper #map div.consent-message button {
  height: auto;
  min-height: 44px;
  max-width: 100%;
  line-height: 1.5;
  white-space: normal;
  padding: 12px 16px;
  border: 1px solid currentColor;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
}
g-maps .g-maps .wrapper #map div.consent-message a:focus-visible, g-maps .g-maps .wrapper #map div.consent-message button:focus-visible {
  outline: 3px solid currentColor;
  outline-offset: 4px;
}
@media (max-width: 759px) {
  g-maps .g-maps {
    margin-bottom: 96px;
  }
  g-maps .g-maps .wrapper #map {
    left: -32px;
    border-radius: 0;
    width: calc(100% + 64px);
  }
}
@media (min-width: 760px) and (max-width: 993px) {
  g-maps .g-maps {
    margin-bottom: 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {
        apiKey: 'AIzaSyCfVvR_7eZvF01dSHLrMlXVRzd7GWNBgqE',
        mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2514.487892434173!2d6.943832876659632!3d50.933189571688466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bf2536e8d8198f%3A0xd5d75e4610ea2c71!2sFASE2!5e0!3m2!1sde!2sde!4v1742637575303!5m2!1sde!2sde',
        placeName: "FASE2",
        address: "Reinoldstraße 6b, 50676 Köln<br>Tel.: 0221 94085999",
        lat: null,
        lng: null,
        rating: null,
        totalReviewCount: 0,
        map: null,
        marker: null,
        infoWindow: null,
        options: null,
        consentMessage: '<div class="consent-message"><p>Die Google-Karte ist aufgrund Ihrer Datenschutzeinstellungen deaktiviert. Für die Anzeige hier auf der Website benötigen wir Ihre Zustimmung zur Kategorie „Präferenzen“.</p><div class="consent-actions"><button type="button" class="open-consent-settings">Datenschutzeinstellungen öffnen</button><a href="https://www.google.com/maps?cid=15408888305095945329" target="_blank" rel="noopener noreferrer">Karte bei Google öffnen</a></div></div>',
        errorMessage: '<div class="consent-message"><p>Die Google-Karte ist hier momentan nicht verfügbar. Sie können unseren Standort direkt bei Google öffnen.</p><a href="https://www.google.com/maps?cid=15408888305095945329" target="_blank" rel="noopener noreferrer">Karte bei Google öffnen</a></div>',
        loadingMessage: '<div class="consent-message"><p>Die Google-Karte wird geladen …</p></div>'
    },
    methods: {
        showMapMessage(message) {
            const container = $refs['g-maps']?.querySelector('#map');
            if (container)
                container.innerHTML = message;
        },
        startMap() {
            if (!window.koppaConsentManager?.hasConsent('preferences'))
                return;
            this.extractCoordinates();
            this.initMap().catch(error => {
                console.error('Google Maps konnte nicht angezeigt werden:', error);
                this.showMapMessage(window.koppaConsentManager?.hasConsent('preferences')
                    ? this.errorMessage : this.consentMessage);
            });
        },
        getScriptUrl() {
            return \`https://maps.googleapis.com/maps/api/js?key=$-{this.apiKey}&libraries=marker,places\`;
        },
        generateLargerMapLink() {
            return \`https://www.google.com/maps/place/FASE2/@50.933193,6.9438329,691m/data=!3m2!1e3!4b1!4m6!3m5!1s0x47bf2536e8d8198f:0xd5d75e4610ea2c71!8m2!3d50.9331896!4d6.9464078!16s%2Fg%2F11x374546f?entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D\`;
        },
        generateRouteLink() {
            return \`https://www.google.com/maps/dir//FASE2,+Reinoldstrasse,+Innenhof+6b%2FEG+rechts,+50676+K%C3%B6ln/@50.9332364,6.9052084,11055m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x47bf2536e8d8198f:0xd5d75e4610ea2c71!2m2!1d6.9464078!2d50.9331896?entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D\`;
        },
        generateReviewLink() {
            const searchQuery = encodeURIComponent(\`$-{this.placeName}, $-{this.address}\`);
            return \`https://www.google.com/search?client=firefox-b-d&sca_esv=1c533a2b97a347ae&sxsrf=AHTn8zoBbP4HTsKwD26ef_V3BU0bmEk5Ww:1743423040307&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzafNj-W9R6AuX-NJPtIoiQhnpWSr-guvShKDpV1P0oVAgZmakDLIa9Yy5U1P-DoJHadIWQ1Dzi9dXUqOcJ9zZnsAYcXs&q=FASE2+Rezensionen&sa=X&ved=2ahUKEwjg34r4pLSMAxXn0wIHHRgZJokQ0bkNegQINhAE&biw=1920&bih=919&dpr=1\`;
        },
        extractCoordinates() {
            const url = new URL(this.mapUrl);
            const params = new URLSearchParams(url.search);
            const pb = params.get('pb');
            const regex = /!2d([-+]?[0-9]*\.?[0-9]+)!3d([-+]?[0-9]*\.?[0-9]+)/;
            const match = pb.match(regex);
            if (match) {
                const extractedLng = parseFloat(match[1]);
                const extractedLat = parseFloat(match[2]);
                if (!isNaN(extractedLat) && !isNaN(extractedLng)) {
                    this.lat = extractedLat;
                    this.lng = extractedLng;
                }
                else {
                    console.error('Ungültige Koordinaten: ', extractedLat, extractedLng);
                }
            }
            else {
                console.error('Koordinaten konnten nicht aus der URL extrahiert werden.');
            }
        },
        generateInfoWindowContent() {
            return \`
                    <div class="info-window">
                        <h3>$-{this.placeName}</h3>
                        <p>$-{this.address}</p>
                        <div class="rating">
                            <span class="rating-value">$-{this.rating?.toFixed(1) || '–'}</span> 
                            <span class="star">⭐</span> 
                            <span>($-{this.totalReviewCount} Bewertungen)</span>
                        </div>
                        <a class="route-link" href="$-{this.generateRouteLink()}" target="_blank">Routenplaner</a>
                        <br/>
                        <a class="map-link" href="$-{this.generateLargerMapLink()}" target="_blank">Größere Karte ansehen</a>
                        <br/>
                        <a class="review-link" href="$-{this.generateReviewLink()}" target="_blank">Bewertungen anzeigen</a>
                    </div>
                \`;
        },
        async waitForLibrary(libName, maxTries = 10) {
            for (let i = 0; i < maxTries; i++) {
                try {
                    const lib = await google.maps.importLibrary(libName);
                    if (lib)
                        return lib;
                }
                catch (e) {
                    console.warn(\`Versuch $-{i + 1}: $-{libName} konnte noch nicht geladen werden.\`);
                }
                await new Promise(r => setTimeout(r, 300));
            }
            throw new Error(\`Library $-{libName} konnte nicht geladen werden.\`);
        },
        async initMap() {
            if (!window.koppaConsentManager?.hasConsent('preferences'))
                return;
            if (typeof google === 'undefined' || !google.maps?.Marker || !google.maps?.Map || !google.maps?.InfoWindow) {
                console.warn("Google Maps Libraries noch nicht vollständig geladen.");
                setTimeout(() => this.startMap(), 250);
                return;
            }
            const mapContainer = $refs['g-maps'].querySelector('#map');
            if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
                console.warn('Google Maps nicht geladen.');
                return;
            }
            if (!this.lat || !this.lng) {
                console.error('Ungültige Koordinaten – Karte wird nicht geladen.');
                return;
            }
            const position = { lat: this.lat, lng: this.lng };
            const { Map } = await this.waitForLibrary("maps");
            const { Marker } = await this.waitForLibrary("marker");
            const { InfoWindow } = await this.waitForLibrary("places");
            if (!window.koppaConsentManager?.hasConsent('preferences'))
                return;
            mapContainer.innerHTML = "";
            this.map = new Map(mapContainer, {
                center: position,
                zoom: 14,
                styles: this.options,
                mapTypeControl: false,
                mapId: '189c58098134624a',
            });
            this.marker = new google.maps.Marker({
                position: position,
                map: this.map,
                title: this.placeName,
            });
            this.infoWindow = new google.maps.InfoWindow({
                content: this.generateInfoWindowContent(),
            });
            this.infoWindow.open(this.map, this.marker);
            this.marker.addListener('click', () => {
                this.infoWindow.open(this.map, this.marker);
            });
            console.log('Google Maps Karte erfolgreich initialisiert.');
        },
        onConsentChanged(event) {
            console.log('Consent changed:', event.detail);
            const { category, value } = event.detail;
            if (category !== 'preferences')
                return;
            const scriptUrl = this.getScriptUrl();
            if (value === true && window.koppaConsentManager?.hasConsent('preferences')) {
                this.showMapMessage(this.loadingMessage);
                if (scriptController.getScriptStatus(scriptUrl) === "loaded") {
                    this.startMap();
                }
                else {
                    scriptController.onEvent(scriptUrl, "onLoad", () => {
                        this.startMap();
                    });
                    scriptController.useScript(scriptUrl, { globalVar: "google" })
                        .catch((e) => {
                        console.error("Google Maps konnte nicht geladen werden:", e);
                        this.showMapMessage(window.koppaConsentManager?.hasConsent('preferences')
                            ? this.errorMessage : this.consentMessage);
                    });
                }
            }
            else {
                const mapContainer = $refs['g-maps'].querySelector('#map');
                mapContainer.innerHTML = this.consentMessage;
                this.map = null;
                this.marker = null;
                this.infoWindow = null;
            }
        },
    },
    mounted() {
        console.log('Mounted g-maps component');
        const scriptUrl = this.getScriptUrl();
        window.addEventListener('consentChanged', this.onConsentChanged);
        if (!window.koppaConsentManager?.hasConsent('preferences')) {
            console.warn("Consent für 'preferences' nicht erteilt – Google Maps wird nicht geladen.");
            return;
        }
        this.showMapMessage(this.loadingMessage);
        this.extractCoordinates();
        const tryLoadRatingInfo = () => {
            const ratingInfoRaw = localStorage.getItem('place_rating_info');
            if (ratingInfoRaw) {
                const info = JSON.parse(ratingInfoRaw);
                const isFresh = (new Date() - new Date(info.timestamp)) / (1000 * 3600 * 24) <= 30;
                if (isFresh && typeof info.rating === 'number' && typeof info.total === 'number') {
                    this.rating = info.rating;
                    this.totalReviewCount = info.total;
                    return true;
                }
            }
            return false;
        };
        const waitForRatingDataAndInitMap = () => {
            if (!window.koppaConsentManager?.hasConsent('preferences'))
                return;
            if (tryLoadRatingInfo()) {
                this.startMap();
            }
            else {
                setTimeout(waitForRatingDataAndInitMap, 1000);
            }
        };
        if (scriptController.getScriptStatus(scriptUrl) === "loaded") {
            waitForRatingDataAndInitMap();
        }
        scriptController.onEvent(scriptUrl, "onLoad", () => {
            waitForRatingDataAndInitMap();
        });
        scriptController.useScript(scriptUrl, { globalVar: "google" })
            .catch((e) => {
            console.error("Google Maps konnte nicht geladen werden:", e);
            this.showMapMessage(window.koppaConsentManager?.hasConsent('preferences')
                ? this.errorMessage : this.consentMessage);
        });
    },
    events: [
        ['click', '$refs.g-maps', function (event) {
                if (!event.target.closest('.open-consent-settings'))
                    return;
                event.preventDefault();
                window.koppaConsentManager?.openCookieBanner();
            }],
    ],
    destroyed() {
        window.removeEventListener('consentChanged', this.onConsentChanged);
    }
};
 })()`
    };
  